import { createStoreConfig } from "./common";
import { getName } from "@/services/utils/Arrays";

const endpoints = {
    getItems: { method: "get", url: "/ads_cabinets" },
};

const baseStore = createStoreConfig<AdsCabinet>(endpoints, "ads_cabinet_dictionari", {
    order_by: "name",
    in: "id__in",
    pk: "id",
    ilike: "search_ilike",
    nameKeys: ["name", "source.name"],
    sortOptions: { primarySortField: "name" }
});

export const useAdsCabinetsDictionariesStoreBase = baseStore;

export const useAdsCabinetsDictionariesStore = () => {
    const store = useAdsCabinetsDictionariesStoreBase();

    return new Proxy(store, {
        get(target, prop) {
            if (prop === 'itemsWithName') {
                return target.itemList.map((e: AdsCabinet) => {
                    const baseFormattedName = getName(e, ["name", "source.name"]);
                    const platformName = e.source?.name;

                    let formattedName = baseFormattedName;
                    if (platformName) {
                        formattedName = formattedName.replace(` (${platformName})`, `, ${platformName}`);
                    }

                    if (e.external_id) {
                        formattedName += ` (exId: ${e.external_id})`;
                    }

                    return {
                        ...e,
                        name: formattedName
                    };
                });
            }
            if (prop === 'getItems') {
                const originalGetItems = (target as any)[prop];
                return async function (
                    pattern__ilike = "",
                    preferredOrder: string[] = [],
                    need_sort = true,
                    get_preferred = false,
                    page = 0,
                    per_page = 50,
                    isInitialLoad = false
                ) {
                    const originalBuildRequestParams = target.buildRequestParams;
                    target.buildRequestParams = function (
                        pattern__ilike: string,
                        preferredOrder: string[],
                        per_page: number
                    ) {
                        const params = originalBuildRequestParams.call(
                            this,
                            pattern__ilike,
                            preferredOrder,
                            per_page
                        );
                        params.use_in_ui = true;
                        return params;
                    };

                    try {
                        const result = await originalGetItems.call(
                            target,
                            pattern__ilike,
                            preferredOrder,
                            need_sort,
                            get_preferred,
                            page,
                            per_page,
                            isInitialLoad
                        );
                        return result;
                    } finally {
                        target.buildRequestParams = originalBuildRequestParams;
                    }
                };
            }
            return (target as any)[prop];
        }
    });
};

export interface AdsCabinet {
    id: number,
    is_archived: boolean,
    is_deleted: boolean,
    login: string,
    name: string,
    source_slug: string,
    external_id?: string | null,
    source?: {
        name: string
    }
}
